<template>
  <div class="new-section competitions">
      <div class="m-container">
<!--        <p class="section-head">our competitions</p>-->
<!--        <p class="section-title wro-bold">Zero1 Super Games 2021</p>-->
        <div class="virtual-games-content competitions-content">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div class="content-holder">
                <div class="img-holder-t">
                  <img height="100" src="@/assets/img/competitions/zero.png">
                </div>
                <p class="c-t">Join the competition. Learn, code, compete in any of the following categories.</p>
                <div class="content-holder-text">
<!--                  <div>-->
<!--                    Starting in 2004, World Robot Olympiad has developed to a-->
<!--                    truly global competition.-->
<!--                  </div>-->
                  <div><a>Virtual Elementary </a></div>
                  <div><a>Virtual Junior </a></div>
                  <div><a>Virtual Senior </a></div>
                  <!-- about us button -->
                  <div class="the-button">
                    <button @click="redirectTo('/sign-In')" class="wro-button secondaryButtons"><span>{{this.$store.state.userState ? 'Profile' : 'Register / Login'}}</span></button>
                    <span class="skew-line-w"></span>
                  </div>
                  <!-- about us button -->
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 img-holder">
              <img  src="@/assets/img/home/group23.png">
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  methods:{
    redirectTo(e){
      this.$router.replace(e);
    }
  }
}
</script>
<style>
.competitions{
  background: #F7FAFD;
}

.competitions .competitions-content{
  margin: 24px 0px;
}

.competitions .content-holder {
  padding-top: 0px!important;
}

.competitions .img-holder img{
  max-width: 450px;
}

.competitions .content-holder p.c-t{
  font-size: 1.125rem!important;
  margin-bottom: 15px!important;
}

.competitions .content-holder-text > div {
  margin-bottom: 15px!important;
}

.competitions .img-holder-t{
  margin-bottom: 10px;
  padding: 20px!important;
  background: var(--mainColors)!important;
  width: max-content;
  border-radius: 20px!important;
}

.competitions .img-holder-t img{
  /*padding: 15px;*/
  /*background: #0093d2;*/
}


@media (max-width: 1079px) {
  .competitions .img-holder img{
    margin: auto;
  }
}

@media (max-width: 465px) {
  .competitions .img-holder img{
    width: 100%;
  }
}




</style>